/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.link.js";
import wx from "weixin-js-sdk";
import Vue from 'vue';
Vue.prototype.$wechat = wx;
/* JS-SDK 配置 */

Vue.prototype.$wechat.initConfig = function (data) {
  wx.config({
    debug: false,
    // 开启调试模式,调用的所有api的返回值会在客户端alert出来
    appId: data.appid,
    // 必填，公众号的唯一标识
    timestamp: data.timestamp,
    // 必填，生成签名的时间戳
    nonceStr: data.noncestr,
    // 必填，生成签名的随机串
    signature: data.signature,
    // 必填，签名
    jsApiList: ['checkJsApi', // 即将废弃
    // 'onMenuShareTimeline',
    // 'onMenuShareQQ',
    // 'onMenuShareAppMessage',
    'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'],
    // 必填，需要使用的JS接口列表,这里填的就是消息订阅用到的开放标签
    openTagList: ['wx-open-subscribe']
  });
}; // 关闭微信页面


Vue.prototype.$wechat.closeWechatPage = function () {
  if (typeof WeixinJSBridge == 'undefined') return;
  WeixinJSBridge.call("closeWindow");
};
/* 图片预览 */


Vue.prototype.$wechat.previewPicture = function (current, urls) {
  if (typeof wx == "undefined") return false;
  wx.previewImage({
    current: current,
    urls: urls
  });
};
/* 微信扫一扫 */


Vue.prototype.$wechat.QRCode = function () {
  if (typeof wx == "undefined") return false;
  wx.scanQRCode({
    desc: 'scanQRCode desc',
    needResult: 0,
    // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ["qrCode", "barCode"],
    // 可以指定扫二维码还是一维码，默认二者都有
    success: function success(res) {
      console.log(res, '成功回调'); // 回调
    },
    error: function error(res) {
      if (res.errMsg.indexOf('function_not_exist') > 0) {
        alert('版本过低请升级');
      }
    }
  });
};
/* 微信分享转发 */

/* 需在用户可能点击分享按钮前就先调用 */


Vue.prototype.$wechat.share = function (o) {
  if (typeof wx == "undefined") return false;
  var a = o || {},
      t = document.title,
      h = location.href,
      d = new Date(),
      s = document.getElementsByTagName('img');
  var title = a.title || t,
      desc = a.desc || '',
      link = a.link || h,
      imgUrl = a.imgUrl || ''; // 默认第一张图片

  if (!a.imgUrl && s.length > 0) imgUrl = s[0].src; // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容

  wx.updateAppMessageShareData({
    title: title,
    // 分享标题
    desc: desc,
    // 分享描述
    link: link,
    // 分享链接
    imgUrl: imgUrl,
    // 分享图标
    success: function success() {},
    // 用户确认分享后执行的回调函数
    cancel: function cancel() {} // 用户取消分享后执行的回调函数

  }); // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容

  wx.updateTimelineShareData({
    title: title,
    // 分享标题
    desc: desc,
    // 分享描述
    link: link,
    // 分享链接
    imgUrl: imgUrl,
    // 分享图标
    success: function success() {},
    // 用户确认分享后执行的回调函数
    cancel: function cancel() {} // 用户取消分享后执行的回调函数

  }); // 分享到腾讯微博

  wx.onMenuShareWeibo({
    title: title,
    // 分享标题
    desc: desc,
    // 分享描述
    link: link,
    // 分享链接
    imgUrl: imgUrl,
    // 分享图标
    success: function success() {},
    // 用户确认分享后执行的回调函数
    cancel: function cancel() {} // 用户取消分享后执行的回调函数

  });
};
/* 微信上传多张图片 */


Vue.prototype.$wechat.multiUpload = function (config, callback) {
  if (typeof wx == "undefined") return false;
  wx.chooseImage({
    count: config.chooseImageCount,
    // 最多可以选择的图片张数
    sizeType: ['original', 'compressed'],
    // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ['album', 'camera'],
    // 可以指定来源是相册还是相机，默认二者都有
    success: function success(res) {
      // Vue.$vux.loading.show({ text: '上传中...' })
      var localIds = res.localIds;

      if (localIds.length > 0) {
        var serverId = [];
        var i = 0;

        function upload() {
          wx.uploadImage({
            localId: localIds[i],
            isShowProgressTips: 0,
            // 是否显示加载中loading  0：不显示   1：显示    （上传多张时loading会循环加载）
            success: function success(resoure) {
              serverId.push(resoure.serverId);
              i++;

              if (i < localIds.length) {
                upload();
              } else {
                callback(serverId);
              }
            },
            fail: function fail(resoure) {
              upload();
            }
          });
        }

        upload();
      }
    }
  });
};